<template>
  <div id="dashboard">
    <div v-if="user.lease_installer_id" class="container bg-gray">
      <div class="row">
        <div id="schedule" class="col-xs-12 col-md-8">
          <div class="card-wrap" style="padding: 0 16px;">
            <div class="card-content">
              <calendar v-model="schedule"
                        :height="560"
                        @updateCalendar="getSchedule"
                        @click="clickSchedule"></calendar>
            </div>
          </div>
        </div>
        <div id="alarm" class="col-xs-12 col-md-4">
          <div class='card-wrap'>
            <div class="card-content">
              <div class="card-header">
                <h4 class="title">신규알람</h4>
                <div class="pull-right">
                  <button type="button"
                          :class="['hz-btn-default', 'hz-btn-xs', {'alarm-active': !isRead}]"
                          @click="isRead = false">읽지않음</button>
                  <button type="button"
                          :class="['hz-btn-default', 'hz-btn-xs', {'alarm-active': isRead}]"
                          @click="isRead = true">읽음</button>
                </div>
              </div>
              <div class="card-body" style="height: 454px; padding:0; overflow-y: auto;">
                <ul v-if="selectedAlarmList.length > 0" class="alarm-list">
                  <li v-for="alarm in selectedAlarmList" :key="alarm.id"
                      @click.prevent="clickAlarm(alarm)">
                    <div class="feed-content">
                      <div class="feed-profile">
                        <div class="user-circle pull-left">
                          <i class="glyphicon glyphicon-user"></i>
                        </div>
                        <div :class="['feed-profile-info', { 'read-alarm': !isRead }]">
                          <strong>{{ alarm.customer__name | nullCheck }}</strong><br>
                          <small class="small">{{ alarm.updated | formatDate }} |</small>
                          <small class="small">{{ alarm.tags | nullCheck }}</small>
                        </div>
                      </div>
                      <p>{{ alarm.message | nullCheck }}</p>
                    </div>
                  </li>
                </ul>
                <div v-else class="text-align-center"
                     style="height: 100%; width: 100%; line-height: 478px;">알람이 없습니다.</div>
              </div>
              <div class="card-footer">
                <router-link :to="{name: 'customer'}">고객목록 확인</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div id="progress" class="col-xs-12 col-md-6">
          <div class="card-wrap">
            <div class="card-content">
              <div class="card-header">
                <h4 class="title">목표달성현황</h4>
              </div>
              <div class="card-body">
                <div class="business-type-counts" v-for="p in progressList">
                  <span>{{ p.title }}</span>
                  <div class="chart-refs pull-right"
                       v-for="badge in p.badge.slice().reverse()">
                    <span :class="['badge', badge.class]"></span><small>{{ badge.name }}</small>
                  </div>
                  <div class="progress">
                    <div v-for="progress in p.progress"
                         :class="['progress-bar', progress.class]"
                         :style="{width: progress.rate + '%'}"
                         role="progressbar">{{ progress.count }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="step" class="col-xs-12 col-md-6">
          <div class="card-wrap">
            <div class="card-content">
              <div class="card-header">
                <h4 class="title">단계별현황</h4>
              </div>
              <div class="card-body">
                <div v-for="s in stepList" class="customer-steps-list col-xs-6"
                     @click="clickStep(s.name)">
                  <label class="step-title">{{ s.name }}</label>
                  <div class="pull-right">
                    <span>{{ stepState.step[s.name] }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="user.lease_installer_id" role="button" class="fab"
         aria-label="고객신규등록"
         aria-tooltip="고객신규등록"
         @click.prevent="addCustomer">
      <img src="../../assets/svg/ic-plus-white.svg" class="icon">
    </div>
    <!-- 접속한 유저가 등록된 시공사가 아닐 경우 문구출력 -->
    <p v-if="!user.lease_installer_id" class="page-none-text">등록된 시공사가 아닙니다.</p>
    <!-- 신규고객 등록창 -->
    <add-customer ref="customerModal" @refresh="init"></add-customer>
  </div>
</template>

<script>
  import Calendar from 'common/components/Calendar'
  import AddCustomer from '@/components/AddCustomerModal'
  import api from '@/api/solarhome'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'dashboard',
    components: {
      Calendar,
      AddCustomer
    },
    data: function () {
      return {
        isRead: false,
        schedule: [], // 캘린더에 바인딩 될 스케쥴 목록
        alarmList: [],
        stepState: {
          'status': {
            '해줌': {
              '계약': 0,
              '시공': 0,
              '미정': 0
            },
            '시공사': {
              '계약': 0,
              '시공': 0,
              '미정': 0
            }
          },
          'progress': {
            'total': 0,
            'complete': 0
          },
          'step': {
            '전체': 0,
            '신규배정': 0,
            '시공방문': 0,
            '신청취소': 0,
            'ㅇ': 0,
            '서류부적합': 0,
            '정산요청': 0,
            '계약완료': 0,
            '정산대기': 0,
            '현장검토': 0,
            '계약취소': 0,
            '정산완료': 0,
            '시공완료': 0
          },
          'goal': {
            '해줌': 0,
            '시공사': 0
          }
        },
        stepList: [ // 단계별현황 리스트
          {name: '전체', value: '전체'},
          {name: '신규배정', value: '신규배정'},
          {name: '현장검토', value: '현장검토'},
          {name: '계약완료', value: '계약완료'},
          {name: '시공방문', value: '시공방문'},
          {name: '시공완료', value: '시공완료'},
          {name: '정산요청', value: '정산요청'},
          {name: '정산대기', value: '정산대기'},
          {name: '서류부적합', value: '서류부적합'},
          {name: '정산완료', value: '정산완료'}
        ]
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      selectedAlarmList: function () {
        const type = this.isRead
        const list = this.alarmList
        let filterList = []

        // 알람 목록이 있을 경우에만 실행
        if (list.length > 0) {
          // 현재 선택된 알람 타입에(읽음-읽지않음) 따라 분류된 리스트를 만든다.
          filterList = _.filter(list, function (o) { return o.is_read === type })
        }

        // 리스트 반환
        return filterList
      },
      progressList: function () {
        const step = this.stepState
        let result = [
          {
            title: '해줌영업',
            badge: [
              {name: '계약', class: 'chart-order-c-01'},
              {name: '시공', class: 'chart-order-c-02'},
              {name: '미정', class: 'chart-order-c-03'}
            ],
            progress: [
              {
                name: '계약',
                count: '',
                rate: 0,
                class: 'chart-order-c-01'
              },
              {
                name: '시공',
                count: '',
                rate: 0,
                class: 'chart-order-c-02'
              },
              {
                name: '미정',
                count: '',
                rate: 0,
                class: 'chart-order-c-03'
              }
            ]
          },
          {
            title: '회원사영업',
            badge: [
              {name: '계약', class: 'chart-order-c-01'},
              {name: '시공', class: 'chart-order-c-02'},
              {name: '미정', class: 'chart-order-c-03'}
            ],
            progress: [
              {
                name: '계약',
                count: '',
                rate: 0,
                class: 'chart-order-c-01'
              },
              {
                name: '시공',
                count: '',
                rate: 0,
                class: 'chart-order-c-02'
              },
              {
                name: '미정',
                count: '',
                rate: 0,
                class: 'chart-order-c-03'
              }
            ]
          },
          {
            title: '전체고객수',
            badge: [
              {name: '사용전점검완료', class: 'chart-order-c-02'},
              {name: '미정', class: 'chart-order-c-03'}
            ],
            progress: [
              {
                name: '사용전점검완료',
                count: '',
                rate: 0,
                class: 'chart-order-c-02'
              },
              {
                name: '미정',
                count: '',
                rate: 0,
                class: 'chart-order-c-03'
              }
            ]
          }
        ]

        // 단계별 현황 그래프에 쓰일 데이터 가공
        if (typeof step.goal !== 'undefined') {
          const haezoom = step.status['해줌']
          const partner = step.status['시공사']
          const business = step['progress']

          // 해줌영업 그래프 데이터 (계약)
          result[0].progress[0].count = haezoom['계약'] ? haezoom['계약'] : ''
          result[0].progress[0].rate = haezoom['계약'] / step.goal['해줌'] * 100
          // 해줌영업 그래프 데이터 (시공)
          result[0].progress[1].count = haezoom['시공'] ? haezoom['시공'] : ''
          result[0].progress[1].rate = haezoom['시공'] / step.goal['해줌'] * 100
          // 해줌영업 그래프 데이터 (미정)
          result[0].progress[2].count = haezoom['미정'] ? haezoom['미정'] : ''
          result[0].progress[2].rate = 100 - (haezoom['계약'] / step.goal['해줌'] * 100) - (haezoom['시공'] / step.goal['해줌'] * 100)

          // 회원사영업 그래프 데이터 (계약)
          result[1].progress[0].count = partner['계약'] ? partner['계약'] : ''
          result[1].progress[0].rate = partner['계약'] / step.goal['시공사'] * 100
          // 회원사영업 그래프 데이터 (시공)
          result[1].progress[1].count = partner['시공'] ? partner['시공'] : ''
          result[1].progress[1].rate = partner['시공'] / step.goal['시공사'] * 100
          // 회원사영업 그래프 데이터 (미정)
          result[1].progress[2].count = partner['미정'] ? partner['미정'] : ''
          result[1].progress[2].rate = 100 - (partner['계약'] / step.goal['시공사'] * 100) - (partner['시공'] / step.goal['시공사'] * 100)

          // 전체고객수 그래프 데이터 (사용전점검완료)
          result[2].progress[0].count = business['complete'] ? business['complete'] : ''
          result[2].progress[0].rate = business['complete'] / business['total'] * 100
          // 전체고객수 그래프 데이터 (미정)
          result[2].progress[1].count = business['total'] - business['complete']
          result[2].progress[1].rate = 100 - (business['complete'] / business['total']) * 100
        }

        return result
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      init: function () {
        this.getAlarm()
        this.getSteps()
      },
      getAlarm: function () {
        const vm = this
        // 알람정보 불러오기
        api.getAlarm(response => {
          if (response.error) {
            console.log('getAlarm error!', response)
          } else {
            // 알람 목록을 넣어준다.
            vm.alarmList = response.data.results
          }
        })
      },
      getSteps: function () {
        const vm = this
        // 단계별 현황 정보 불러오기
        api.getSteps(response => {
          if (response.error) {
            console.log('getSteps error!', response)
          } else {
            // 단계별 현황 정보를 넣어준다.
            vm.stepState = response.data
          }
        })
      },
      getSchedule: _.debounce(function (date) {
        const vm = this
        // 시공정보(스케쥴) 불러오기
        api.getSchedule(date, response => {
          if (response.error) {
            vm.showToastMessage('시공일정 불러오기 실패')
            console.log('getSchedule error!', response)
          } else {
            // 캘린더에 표시할 스케쥴 목록을 만들어준다.
            if (response.data) {
              vm.schedule = vm.setSchedule(response.data)
            }
          }
        })
      }, 300),
      setSchedule: function (data) {
        let list = []

        // 스케쥴 api 데이터 가공, full-calendar에 쓰일 수 있는 형태로 스케쥴 데이터 생성
        const setList = function (id, region, state, name, start, end) {
          return {id: id, title: '[' + state + '] ' + name + ' ' + state, start: start, end: end}
        }

        // 스케쥴 목록 생성
        for (let i in data) {
          const event = data[i]
          let startDate, endDate

          // 검토예정, 검토완료 일정이 있을 경우 리스트애 추가
          if (event.check_spot_start_date && event.check_spot_end_date) {
            startDate = moment(event.check_spot_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
            endDate = moment(event.check_spot_end_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
            list.push(setList(event.id, event.region, '검토', event.name, startDate, endDate))
          }

          // 시공예정, 시공완료 일정이 있을 경우 리스트애 추가
          if (event.install_start_date && event.install_end_date) {
            startDate = moment(event.install_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD')
            endDate = moment(event.install_end_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
            list.push(setList(event.id, event.region, '시공', event.name, startDate, endDate))
          }
        }

        // 스케쥴 목록 반환
        return list
      },
      clickSchedule: function (id) {
        if (id) {
          // 고객관리 페이지로 이동한다.
          this.$router.push({name: 'customer', query: {id: id}})
        }
      },
      clickAlarm: function (data) {
        // 클릭된 알람이 읽지않음 상태 일 경우, 읽음 상태로 변경한다.
        if (!data.is_read) {
          this.readAlarm(data.id)
        }
        // 고객관리 페이지로 이동한다.
        this.$router.push({name: 'customer', query: {id: data.customer}})
      },
      readAlarm: function (id) {
        const vm = this
        // 알람을 읽음 상태로 변경한다.
        api.readAlarm(id, response => {
          if (response.error) {
            console.log('change Alarm error!', response)
            vm.showToastMessage('알람 상태변경 실패')
          }
        })
      },
      clickStep: function (step) {
        // 진행단계 클릭 시 조건에 맞는 필터를 설정 후 고객관리 페이지로 이동한다.
        if (step === '전체') {
          // 고객관리 페이지로 이동한다.
          this.$router.push({name: 'customer'})
        } else {
          const filter = {
            logic: 'and',
            filters: [{field: 'biz_step__name', operator: 'eq', value: step}]
          }
          // 필터값을 쿼리셋에 설정 후 고객관리 페이지로 이동한다.
          this.$router.push({name: 'customer', query: {filter: $.param(filter)}})
        }
      },
      addCustomer: function () {
        // 신규고객 등록창을 띄운다.
        this.$refs.customerModal.show()
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')

      // 사용자 인증 (토큰)
      if (token) {
        // 토큰 검증 및 갱신 성공 시 화면렌더 및 데이터 초기화.
        vm.$store.dispatch('inspectToken', token).then(() => {
          vm.init()
        })
      } else {
        alert('로그인이 필요한 서비스 입니다. 로그인 화면으로 이동합니다.')
        vm.$router.push({name: 'login'})
      }
    },
    mounted: function () {
    },
    beforeDestroy: function () {
      // 켄도 라이브러리에 의해 생성된 찌꺼기 엘리먼트 초기화.
      kendo.destroy(document.body)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  #dashboard {
    height: auto;
    background-color: $light-grey;

    .container {
      padding: 16px 0;
    }

    .card-wrap {
      width: 100%;
      height: 100%;
      background-color: $hzc-white;
      box-shadow: $z-depth-01;

      .card-content {

        .card-header {
          padding: 20px 24px;
          .title {
            display: inline-block;
            margin: 0;
          }
        }

        .card-body {
          padding: 24px;
        }

        .card-footer {
          padding: 20px 24px;
          border-top: 1px solid $border-color;
        }
      }
    }

    #schedule {
      height: 600px;
      padding: 16px 8px 8px 16px;
    }

    #alarm {
      height: 600px;
      padding: 16px 16px 8px 8px;

      .alarm-active {
        background-color: darken($hzc-white, 10%);
        color: $font-color;
        border-color: darken($border-color, 10%);
      }

      .alarm-list {
        margin: 0;
        padding: 0;
        list-style: none;
        > li {
          cursor: pointer;

          &:hover {
            background-color: darken($hzc-white, 10%);
            border-color: darken($border-color, 10%);
          }

          .feed-content {
            border-bottom: 1px solid $hzc-gray-03;
            padding: 16px 24px;
            cursor: pointer;

            .feed-profile {
              margin-bottom: 8px;
              white-space: nowrap;
              word-wrap: break-word;

              .user-circle {
                width: 40px;
                height: 40px;
                background: $hzc-gray-05;
                border-radius: 20px;
                text-align: center;
                i {
                  color: $hzc-white;
                  font-size: 24px;
                  line-height: 36px;
                }
              }

              .feed-profile-info {
                padding: 2px 0 0 12px;
                display: inline-block;
                > strong {
                  line-height: 16px;
                  font-size: 16px;
                  margin: 0px
                }
                > small {
                  color: $hzc-gray-05;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }

      .read-alarm {
        color: $hzc-gray-05;
      }
    }

    #progress {
      height: 354px;
      padding: 8px 8px 16px 16px;

      .business-type-counts {
        margin-bottom: 24px;

        span {
          font-weight: bold;
        }

        .chart-refs {
          margin: 0;

          .badge {
            display: inline-block;
            width: 24px;
            height: 4px;
            border-radius: 1px;
            margin: 0px 8px 4px 8px;
          }
        }

        .progress {
          border-radius: 2px;
          height: 24px;
          margin: 8px 0 0 0;
          > .progress-bar {
            line-height: 24px;
          }
        }
      }
    }

    #step {
      height: 354px;
      padding: 8px 16px 16px 8px;

      .card-body {
        overflow: hidden;
        padding: 0;
      }
      .customer-steps-list {
        width: 50%;
        height: 20%;
        padding: 0 24px;
        border-top: 1px solid $hzc-gray-03;
        border-right: 1px solid $hzc-gray-03;
        display: table-cell;
        line-height: 52px;
        cursor: pointer;

        >label {
          margin: 0;
          font-weight: normal;
          cursor: pointer;
        }
        &:nth-child(2n) {
          border-right: none;
        }
      }
    }

    @media (max-width: 991px) {
      #schedule {
        padding: 16px 16px 8px 16px;
      }
      #alarm {
        padding: 8px 16px 8px 16px;
      }
      #progress{
        padding: 8px 16px 8px 16px;
      }
      #step {
        padding: 8px 16px 16px 16px;
      }
    }

    /* chart Color */
    .chart-order-c-00{
      background-color: $hzc-gray-02;
    }
    .chart-order-c-01 {
      background-color: $hzc-brand-05;
    }
    .chart-order-c-02 {
      background-color: $hzc-brand-03;
    }
    .chart-order-c-03 {
      background-color: $hzc-gray-02;
      color: $hzc-gray-05;
    }

    .fab {
      position: fixed;
      right: 32px;
      bottom: 32px;
      width: 56px;
      height: 56px;
      line-height: 54px;
      background-color: $primary-color-v2;
      border: none;
      border-radius: 28px;
      box-sizing: content-box;
      box-shadow: $z-depth-01;
      cursor: pointer;
      outline: none;
      overflow: hidden;
      text-align: center;
      z-index: 9;
      &:hover {
        background-color: darken($primary-color-v2, 10%);
      }
    }

    .page-none-text {
      position: absolute;
      top: 50%;
      width: 100%;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/solarhome/DashBoard.vue